import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    UrlField,
    ImageField,
    ReferenceField,
    TopToolbar,
    EditButton,
    useRecordContext,
    WithRecord
} from 'react-admin';
import {
    Grid
} from '@mui/material';

const ShowActions = () => {

    return (
        <TopToolbar>
            <EditButton />
        </TopToolbar>
    );
}

const ShowUserTitle = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>{ "Customer Social - " + record.platform }</span>
}

export const AdminSocialShow = () => {

    return(
        <Show actions={ <ShowActions /> } title={ <ShowUserTitle /> }>
            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <WithRecord label="" render={ record => {
                            let platform = record.platform;
                            const url = "/images/social/icons/" + platform.toLowerCase() + ".png";
                            record.image = url;
                            return (
                                <ImageField
                                    source="image"
                                    src={  url }
                                    title={ record.platform }
                                />
                            );
                        }  } />
                        <ReferenceField
                            label="Company"
                            source="company"
                            reference="companies"
                            link="edit">
                            <TextField source="name" />
                        </ReferenceField>
                        <ReferenceField
                            label="Contact"
                            source="contact"
                            reference="people"
                            link="show">
                            <TextField source="name" />
                        </ReferenceField>
                    </SimpleShowLayout>
                </Grid>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="id" />
                        <TextField source="platform" sx={ { textTransform: 'capitalize' } } />
                        <UrlField source="url" />
                    </SimpleShowLayout>
                </Grid>
            </Grid>
        </Show>
    );
}